import {useEffect, useState} from "react";
import {findRunners} from "../../../api/RunnerApi";

export default function UseBuildInitializer({hubId}) {
    const [runners, setRunners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedRunner, setSelectedRunner] = useState(undefined);

    useEffect(() => {
        findRunners()
            .then((runners => {
                setRunners(runners);
                setLoading(false);
            }));
    }, [hubId]);

    const handleRunnerSelected = (runnerId) => {
        const [runner] = runners.filter(runner => runner.id === runnerId);
        setSelectedRunner(runner);
    };

    return {
        loading,
        runners,
        selectedRunner,
        handleRunnerSelected
    }
}